import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import ImageListItemBar from "@material-ui/core/ImageListItemBar";
import imgGaiyang from "../images/gaiyang.jpg";
import imgGeneralThai from "../images/generalthai.jpg";
import imgGreenCurry from "../images/greencurry.jpg";
import imgHotAndSpicy from "../images/hotandspicy.jpg";
import imgHouseNoodle from "../images/housenoodle.jpg";
import imgPadPak from "../images/padpak.jpg";
import imgPadKeeMow from "../images/padkeemow.jpg";
import imgPanag from "../images/panang.jpg";
import imgTomYumNoodleSoup from "../images/tomyumnoodlesoup.jpg";
import imgPadKraPow from '../images/padkrapow.jpg';
import imgPineappleFR from '../images/pineapplefriedrice.jpg';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    flexWrap: "nowrap",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)",
  },
  title: {
    color: '#ffffff',
  },
  titleBar: {
    background:
      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
}));

const itemData = [
  {
    img: imgGaiyang,
    title: "Gai Yang",
  },
  {
    img: imgGeneralThai,
    title: "General Thai Chicken",
  },
  {
    img: imgGreenCurry,
    title: "Green Curry",
  },
  {
    img: imgHotAndSpicy,
    title: "Hot & Spicy",
  },
  {
    img: imgHouseNoodle,
    title: "House Noodle",
  },
  {
    img: imgPadPak,
    title: "Pad Pak",
  },
  {
    img: imgPadKeeMow,
    title: "Pad Kee Mow",
  },
  {
    img: imgPanag,
    title: "Panang Curry",
  },
  {
    img: imgTomYumNoodleSoup,
    title: "Tom Yum Noodle Soup",
  },
  {
    img: imgPadKraPow,
    title: "Pad Gra Pow Kai Dao",
  },
  {
    img: imgPineappleFR,
    title: "Pineapple Fried Frice",
  },
];

export default function SingleLineImageList() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ImageList className={classes.imageList} cols={2.5}>
        {itemData.map((item) => (
          <ImageListItem key={item.img}>
            <img src={item.img} alt={item.title} />
            <ImageListItemBar
              title={item.title}
              classes={{
                root: classes.titleBar,
                title: classes.title,
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  );
}
